export default [
    {
        path: '/volumes/:id',
        name: 'volume',
        meta: {
            category: "servers",
            noAutoTitle: true
        },
        component: () => import('@/views/resources/volume/Volume')
    }
]
